import React from 'react'
import { Field } from 'react-final-form'
import { Form, Popup } from 'semantic-ui-react'
import { SearchLimitStyle, SearchOptionStyle } from './styles'
import { SelectionOptions } from '../SelectionOptions/SelectionOptions'
import { SEARCH_LIMIT_OPTIONS } from '../../consts'
import { useSelector } from 'react-redux'
import { AppState } from '../../redux/store'

interface Props {
  disabled?: boolean
  children?: any
  style?: any
  isBatchLookup?: boolean
}

export const LookupOptionsFormGroup = ({ disabled, children, style, isBatchLookup }: Props) => {
  const { searchFunc } = useSelector((state: AppState) => state.ui)

  const isSql = searchFunc === 'sql'

  return (
    <div style={style}>
      {children || null}
      <div style={{ display: 'inline' }}>
        <Field name="includeRemoved" type="checkbox">
          {(props) => (
            <SearchOptionStyle className="field">
              <div className="ui checkbox">
                <input {...props.input} id="input-include-removed" disabled={disabled} />
                <Popup
                  content="Include removed products"
                  mouseEnterDelay={300}
                  trigger={<label htmlFor="input-include-removed">Include removed</label>}
                />
              </div>
            </SearchOptionStyle>
          )}
        </Field>
        {isSql && !isBatchLookup && (
          <Field name="aliasMode" type="checkbox">
            {(props) => (
              <SearchOptionStyle className="field">
                <div className="ui checkbox">
                  <input {...props.input} id="input-alias-mode" disabled={disabled} />
                  <Popup
                    content="Prioritize alias over name"
                    mouseEnterDelay={300}
                    trigger={<label htmlFor="input-alias-mode">Prioritize alias over name</label>}
                  />
                </div>
              </SearchOptionStyle>
            )}
          </Field>
        )}
      </div>
      <SearchLimitStyle>
        <Form.Field inline>
          <span>Limit:</span>
          <Field name="limit" component="select" disabled={disabled}>
            <SelectionOptions options={SEARCH_LIMIT_OPTIONS} />
          </Field>
        </Form.Field>
      </SearchLimitStyle>
    </div>
  )
}
